import React, { useState, useRef, useLayoutEffect } from 'react';
import { Tooltip, Typography } from 'antd';


export default (props) => {
  const words_str = props.text || '';
  const targetRef = useRef();
  const [ellipsis, setEllipsis] = useState(false);
  const [maxWidth, setMaxWidth] = useState('100%');
  useLayoutEffect(() => {
    // scrollWidth
    if (targetRef.current) {
      const HTML_MAX_WIDTH = window.innerWidth;
      if (HTML_MAX_WIDTH >= 1200) {
        setMaxWidth(props.xlMaxWitdh);
        if (props.xlMaxWitdh === '100%') {
          return setEllipsis(false);
        }
        if (+((props.xlMaxWitdh || '').replace('px', '')) < targetRef.current.scrollWidth) {
          setEllipsis(true);
        }
      }
      if (HTML_MAX_WIDTH > 0 && HTML_MAX_WIDTH < 1200) {
        setMaxWidth(props.lgMaxWitdh);
        if (props.lgMaxWitdh === '100%') {
          return setEllipsis(false);
        }
        if (+((props.lgMaxWitdh || '').replace('px', '')) < targetRef.current.scrollWidth) {
          setEllipsis(true);
        }
      }
    }
  }, []);
  const words = ellipsis ? <Tooltip title={words_str} trigger="hover">{words_str}</Tooltip> : words_str;
  return (
    <div ref={targetRef} style={{ maxWidth: maxWidth }}>
      <Typography.Paragraph ellipsis={ellipsis}>{words}</Typography.Paragraph>
    </div>
  );
}
